import {
  PaymentSummaryContainer,
  SummaryTextRow,
  CurrentSubscriptionRow,
  EditSubscriptionLink,
  PaymentItemRow,
  DiscountItemRow,
  PaymentTotalRow,
  RowLabel,
  RowAmount,
} from './PaymentSummary.styles'
import { formatCurrency, getTotalPrice } from 'utils/Upgrade'

import Link from 'next/link'

export interface PaymentSummaryProps {
  stripePlan: TODO
  editSubscriptionUrl?: string
}
const PaymentSummary = ({ stripePlan, editSubscriptionUrl }: PaymentSummaryProps) => {
  const { stripeCoupon = {}, price, taxes = [], fee = 0, display_name: displayName } = stripePlan
  const hasCoupon = stripeCoupon && Object.keys(stripeCoupon).length > 0

  return (
    <PaymentSummaryContainer>
      <SummaryTextRow>Summary</SummaryTextRow>
      <CurrentSubscriptionRow>
        <RowLabel>
          {displayName} Subscription{' '}
          {editSubscriptionUrl && (
            <Link href={{ pathname: editSubscriptionUrl }} passHref>
              <EditSubscriptionLink>(edit)</EditSubscriptionLink>
            </Link>
          )}
        </RowLabel>
        <RowAmount>{formatCurrency(price)}</RowAmount>
      </CurrentSubscriptionRow>
      {hasCoupon && (
        <DiscountItemRow>
          <RowLabel>{stripeCoupon.name}</RowLabel>
          <RowAmount>{formatCurrency(-stripeCoupon.couponedDiscount)}</RowAmount>
        </DiscountItemRow>
      )}
      {fee > 0 && (
        <PaymentItemRow>
          <RowLabel>One-Time Fee</RowLabel>
          <RowAmount>{formatCurrency(fee)}</RowAmount>
        </PaymentItemRow>
      )}
      {taxes.map(({ amount, rate, type }, i) => (
        <PaymentItemRow key={i}>
          <RowLabel>
            {rate}% {type}
          </RowLabel>
          <RowAmount>{formatCurrency(amount)}</RowAmount>
        </PaymentItemRow>
      ))}
      <PaymentTotalRow>
        <RowLabel>Total</RowLabel>
        <RowAmount>{formatCurrency(getTotalPrice(stripePlan))}</RowAmount>
      </PaymentTotalRow>
    </PaymentSummaryContainer>
  )
}
export default PaymentSummary
